/**
 * usePromptBlocks — 프롬프트 블록 목록 fetch 훅
 */

import { useMemo } from 'react'
import { useApiFetch } from './useApiFetch.js'
import type { PromptBlockType } from '@cugumi/shared/schemas'

/** 유저용 프롬프트 블록 (promptText 제외) */
export interface PromptBlockSummary {
  id: string
  blockType: PromptBlockType
  slug: string
  nameKo: string
  nameEn: string
  imageUrl: string | null
  sortOrder: number
}

interface PromptBlocksResponse {
  blocks: PromptBlockSummary[]
}

/**
 * 활성 프롬프트 블록 목록 조회.
 * blockType을 지정하면 해당 타입만 필터링.
 */
export function usePromptBlocks(blockType?: PromptBlockType) {
  const query = blockType ? `?blockType=${blockType}` : ''
  const { data, error, isLoading, refetch } = useApiFetch<PromptBlocksResponse>(
    `/api/ai/prompt-blocks${query}`,
  )

  return {
    blocks: data?.blocks ?? [],
    error,
    isLoading,
    refetch,
  }
}

/**
 * 모든 블록을 타입별로 그룹핑하여 반환
 */
export function usePromptBlocksGrouped() {
  const { blocks, error, isLoading, refetch } = usePromptBlocks()

  const grouped = useMemo(() => {
    const result: Record<PromptBlockType, PromptBlockSummary[]> = {
      STYLE: [], POSE: [], WARDROBE: [], CAMERA: [],
    }
    for (const b of blocks) {
      result[b.blockType].push(b)
    }
    return result
  }, [blocks])

  return { grouped, blocks, error, isLoading, refetch }
}
